module.exports = __webpack_public_path__ + "static/media/sopt3kz.544e86e5.pdf";